<template>
  <v-row no-gutters>
    <v-col cols="4" class="font-weight-bold">
      {{ title }}:
    </v-col>
    <v-col cols="8">
      {{ val }}
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ['title', 'val']
}
</script>
